import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import NavigationGridItem, { NavigationGridItemStyles } from "@SupplyLand/Components/NavigationGridItem";
import React from "react";
import { FC } from "react";
import { connect } from "react-redux";

interface OwnProps {
    childStyles?: NavigationGridItemStyles;
    categoryId: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: { categoryId: string }) => ({
    category: getCategoryState(state, ownProps.categoryId).value,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CategorySpotlightPanelView: FC<Props> = props => {
    const { childStyles, category } = props;

    if (!category) {
        return null;
    }

    return (
        <NavigationGridItem
            extendedStyles={childStyles}
            pageUrl={category.path}
            imageUrl={category.smallImagePath}
            imageAltText={category.imageAltText}
            pageId={category.id}
            titleText={category.shortDescription}
        />
    );
};

const CategorySpotlightPanel = connect(mapStateToProps)(CategorySpotlightPanelView);
export default CategorySpotlightPanel;
